import createSocket from '@/utils/socket';

export default {
  data() {
    return {
      trainings_socket: null,
      trainings_channel: null,
    };
  },
  methods: {
    trainingsWebsocketChannel() {
      const projectId = sessionStorage.getItem('project_id');
      if (!projectId || projectId === 'undefined') {
        return null;
      }
      return `${projectId}_trainings`;
    },
    setupTrainingsSocket() {
      const channel = this.trainingsWebsocketChannel();
      if (!channel) {
        return;
      }
      if (this.trainings_channel === channel && this.trainings_socket) {
        return;
      }
      this.teardownTrainingsSocket();
      this.trainings_channel = channel;
      const socket = createSocket();
      this.trainings_socket = socket;
      socket.on('connect', () => {
        socket.emit('subscribe', channel);
      });
      socket.on('message', (message) => {
        let payload = null;
        try {
          payload = JSON.parse(JSON.parse(message));
        } catch (e) {
          return;
        }
        if (!payload || payload.type !== 'train_job_update' || !payload.job) {
          return;
        }
        this.applyTrainJobUpdate(payload.job);
      });
    },
    teardownTrainingsSocket() {
      if (this.trainings_socket) {
        this.trainings_socket.close();
      }
      this.trainings_socket = null;
      this.trainings_channel = null;
    },
    applyTrainJobUpdate(job) {
      if (!Array.isArray(this.jobs)) {
        this.jobs = [];
      }
      if (job.deleted_at || job.processed === 1) {
        this.jobs = this.jobs.filter((j) => j.id !== job.id);
        return;
      }
      const idx = this.jobs.findIndex((j) => j.id === job.id);
      if (idx >= 0) {
        const next = this.jobs.slice();
        next[idx] = job;
        this.jobs = next;
      } else {
        this.jobs = [...this.jobs, job];
      }
    },
  },
  beforeUnmount() {
    this.teardownTrainingsSocket();
  },
};
